import styled from 'styled-components';

import { FlexContainer } from 'common/components/atoms';
import Button from 'common/components/atoms/Button';
import InputField_T from 'common/components/Chart/atoms/InputField';
import Label from 'common/typography/Label/Label';

export const TFlexContainer = styled(FlexContainer)`
  line-height: 1.3em;
  padding: 10px;
  margin:1px;
`;

export const CancelButton = styled(Button)`
  margin-right: 20px
`;

export const InputField = styled(InputField_T)`
  padding-top: 0.5em;
  padding-left:0.5em;
  label {
    font-weight: 800;
  }
  margin-bottom: 3px;
`;

export const DemoMachinesField = styled(InputField)`
  .ui.selection.dropdown .menu {
    max-height: 240px;
    overflow-y: auto;
    overflow-x: hidden;
  }
`;

export const ModalActionRow = styled(FlexContainer)`
  margin-top: 20px;
  gap: 12px;
`;

export const DemoToggleRow = styled(FlexContainer)`
  margin: 12px 0 4px;
  align-items: center;
`;

export const DemoHint = styled(Label)`
  color: ${props => props.theme.colors.grey};
  font-size: 12px;
  margin: 2px 0 8px;
`;
